import React, { useEffect, useRef, useState } from 'react';
import MdiIcon from '@mdi/react';
import { mdiDotsVertical, mdiPencilOutline, mdiTrashCanOutline } from '@mdi/js';

interface Props {
  onRename: () => void;
  onDelete: () => void;
}

const RowOverflowMenu: React.FC<Props> = ({ onRename, onDelete }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    if (open) document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="overflow-menu-wrap" ref={ref}>
      <button
        className={`overflow-menu-btn ${open ? 'is-open' : ''}`}
        onClick={e => { e.stopPropagation(); setOpen(v => !v); }}
        title="More actions"
      >
        <MdiIcon path={mdiDotsVertical} size={0.7} />
      </button>
      {open && (
        <div className="overflow-menu">
          <button className="overflow-menu-item" onClick={() => { onRename(); setOpen(false); }}>
            <MdiIcon path={mdiPencilOutline} size={0.65} />
            Rename
          </button>
          <button className="overflow-menu-item overflow-menu-item--danger" onClick={() => { onDelete(); setOpen(false); }}>
            <MdiIcon path={mdiTrashCanOutline} size={0.65} />
            Delete
          </button>
        </div>
      )}
    </div>
  );
};

export default RowOverflowMenu;
